<div class="main">
  <spb-header/>
  <main id="main-content">
    <router-outlet/>
  </main>
  <footer>
    <spb-footer
      [license]="true"
      [version]="version"
      copyrightYears="2024"
    />
  </footer>
</div>